<div class="h-full">
    <div class="flex flex-row justify-end items-center">
        <button mat-icon-button class="close-button" mat-dialog-close>
            <mat-icon class="close-icon" color="accent">close</mat-icon>
        </button>
    </div>
    <div class="sm:px-6 px-1 bg-white h-full ">

        <div class="px-4">

            <div class="flex flex-col justify-center items-center border-b-2 border-[#233E80] w-full text-[#233E80]  h-[50px] ">
                <div>
                    <h2 class="text-xl font-bold" >
                        {{ "Tag" | translate | async }}
                    </h2>
                </div>


            </div>

            <div class="flex justify-center items-center border-b-2 border-[#233E80] w-full " *ngIf="this.data.section">
                <div class="padding column-left">
                    <span class="text-xl font-bold color:#000000">
                        {{ this.data.section | translate | async | uppercase}}
                    </span>
                </div>
                
                <div class="column-right">
                    <button mat-icon-button class="color:#000000" (click)="onDelete()">
                        <mat-icon>delete_outline</mat-icon>
                    </button>
                </div>
            </div>

            <div>
                <div class="flex flex-row justify-center items-center w-full  text-white bg-[#233E80] "></div>
            <div class=" mt-4">
                <app-dynamic-form *ngIf="formGroup" [formGroup]="formGroup" [inputForm]="inputForm"
                    [appearanceForm]="'outline'"> </app-dynamic-form>
            </div>


            <div class="w-full my-4">
                <div class="flex flex-row justify-center items-center">
                    <button mat-flat-button color="accent" [disabled]="!formGroup.valid" (click)="onSave()"
                        class="w-1/3">{{utils.traslatei18n('PostReply')}}</button>
                </div>
            </div>
        </div>

    </div>
</div>